/* ===== カテゴリ・ピル：軽量ポータル（1個だけ開く／SP端に余白） ===== */
  (() => {
    const root = (document.currentScript && document.currentScript.closest('.section')) || document;
    const scroller = root.querySelector('.c-catpills__scroller');
    if (!scroller) return;

    let active = null; // { panel, btn, ph }
    let rafId = 0;

    /* 端の安全マージン（scroller の左右 padding を優先・最低16px） */
    const getEdge = () => {
      const cs = getComputedStyle(scroller);
      const pad = Math.max(parseFloat(cs.paddingLeft) || 0, parseFloat(cs.paddingRight) || 0);
      return Math.max(16, pad);
    };

    /* ---- 位置決め（実寸幅でクランプ／上下フリップ／端に余白） ---- */
    const place = (panel, btn, immediate) => {
      const r = btn.getBoundingClientRect();
      const EDGE = getEdge();

      // 最大幅は端のゆとり込み（先に指定してから実寸取得）
      panel.style.maxWidth = `calc(100vw - ${EDGE * 2}px)`;

      // 最低幅＝ボタン幅以上・220px以上。ただしSPで端に収まるように制限
      const minWBase = Math.max(220, r.width);
      const maxWView = innerWidth - EDGE * 2;
      const minW = Math.min(minWBase, Math.max(180, maxWView));
      if (!panel.__w) {
        panel.style.minWidth = minW + 'px';
        panel.__w = 1;
      }

      // 実寸幅（min/max反映後）を取得し、右端でクランプ
      const rect = panel.getBoundingClientRect();
      const W = Math.min(Math.max(minW, rect.width || minW), maxWView);

      let x = Math.min(Math.max(EDGE, r.left), innerWidth - W - EDGE);
      let y = r.bottom + 8;

      // 高さが入らなければ上側へフリップ（上下もEDGEを確保）
      const H = panel.__h || panel.offsetHeight || panel.scrollHeight || 240;
      panel.__h = H;
      if (y + H > innerHeight - EDGE) {
        const up = Math.max(EDGE, r.top - H - 8);
        if (up + H <= innerHeight - EDGE) y = up;
      }

      const tx = `translate3d(${Math.round(x)}px,${Math.round(y)}px,0)`;
      if (immediate) {
        const prev = panel.style.transition;
        panel.style.transition = 'none';
        panel.style.transform = tx;
        panel.getBoundingClientRect(); // flush
        panel.style.transition = prev || 'opacity .16s ease';
      } else {
        panel.style.transform = tx;
      }
    };

    /* ---- 完全クローズ（同期で即時片付け） ---- */
    const teardown = (panel, btn) => {
      if (!panel) return;

      if (panel.__onUpdate) {
        removeEventListener('scroll', panel.__onUpdate, { capture: true });
        removeEventListener('resize', panel.__onUpdate);
        panel.__onUpdate = null;
      }
      btn && btn.setAttribute('aria-expanded', 'false');

      panel.classList.remove('is-open', 'is-floating');
      panel.hidden = true;
      panel.style.transform = '';
      panel.style.minWidth = '';
      panel.style.maxWidth = '';
      panel.__w = 0;
      panel.__h = 0;

      if (panel.__ph && panel.__ph.parentNode) {
        panel.__ph.parentNode.insertBefore(panel, panel.__ph);
        panel.__ph.remove();
      }
      panel.__ph = null;

      if (active && active.panel === panel) active = null;
    };

    /* ---- 開く（他が開いていれば先に即時クローズ） ---- */
    const open = (panel, btn) => {
      if (active && active.panel !== panel) teardown(active.panel, active.btn);
      if (active && active.panel === panel) {
        teardown(panel, btn);
        return;
      }

      const ph = document.createElement('span');
      ph.style.display = 'none';
      panel.parentNode.insertBefore(ph, panel);
      document.body.appendChild(panel);
      panel.__ph = ph;

      panel.hidden = false;
      panel.classList.add('is-floating');
      place(panel, btn, true);

      requestAnimationFrame(() => {
        panel.classList.add('is-open'); // opacity のみトランジション
        btn.setAttribute('aria-expanded', 'true');
      });

      const onUpdate = () => {
        if (rafId) return;
        rafId = requestAnimationFrame(() => {
          rafId = 0;
          if (active && active.panel === panel) place(panel, btn, false);
        });
      };
      addEventListener('scroll', onUpdate, { passive: true, capture: true });
      addEventListener('resize', onUpdate);
      panel.__onUpdate = onUpdate;

      active = { panel, btn, ph };
    };

    const closeActive = () => {
      if (active) teardown(active.panel, active.btn);
    };

    /* ---- デリゲーション：親ピルのトグル ---- */
    scroller.addEventListener('click', (e) => {
      const btn = e.target.closest('.c-acc__toggle');
      if (!btn) return;
      const panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      open(panel, btn);
    });

    /* ---- 外側クリック／ESCで閉じる ---- */
    document.addEventListener('click', (e) => {
      if (!active) return;
      if (scroller.contains(e.target)) return;
      if (active.panel.contains(e.target)) return;
      closeActive();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeActive();
    });
  })();